import { Zap, Handshake, MessageCircle, Sparkles } from "lucide-react";

const ITEMS = [
  {
    icon: Zap,
    title: "Fast",
    body: "Most sites go live within 7 days. We start the day you confirm.",
  },
  {
    icon: Handshake,
    title: "Fair pricing",
    body: "Fixed quote upfront. No vague hourly bills, no scope creep surprises.",
  },
  {
    icon: MessageCircle,
    title: "Plain English",
    body: "One person, one inbox, real replies. No agency runaround.",
  },
  {
    icon: Sparkles,
    title: "We handle it",
    body: "Hosting, updates, backups, security — all managed for you. Set it once, never think about it again.",
  },
];

export default function ValueProps() {
  return (
    <section data-testid="value-props" className="border-t border-[#E5E0D8] bg-white">
      <div className="oak-container oak-section">
        <div className="max-w-2xl">
          <p className="text-sm uppercase tracking-[0.18em] text-[#5C665F]">Why Oakbridg</p>
          <h2 className="font-heading font-bold text-3xl md:text-5xl tracking-tight mt-3 text-[#1A3622]">
            Built like a small contractor.
            <br />
            Not a big agency.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {ITEMS.map(({ icon: Icon, title, body }, i) => (
            <div
              key={title}
              data-testid={`value-prop-${i}`}
              className="group p-6 rounded-xl border border-[#E5E0D8] bg-[#FAF9F6] transition-all hover:bg-white hover:shadow-md hover:-translate-y-0.5"
            >
              <div className="w-10 h-10 rounded-full bg-[#1A3622] text-white flex items-center justify-center transition-transform group-hover:rotate-[-6deg]">
                <Icon className="w-5 h-5" />
              </div>
              <h3 className="font-heading font-bold text-xl mt-5 text-[#1C211E]">{title}</h3>
              <p className="text-[15px] leading-relaxed text-[#5C665F] mt-2">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
